module.exports = __webpack_public_path__ + "img/home-icon.bd88b09e.svg";